import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// import Dashboard from './components/dashboard';
import Contact from './pages/contact';
import HomePage from './pages/Homepage';
import AboutPage from './pages/aboutUs';
import ServicesPage from './pages/servicesPage';
import TestimonialPage from './pages/testimonialPage';

import Login from "./pages/login";
import AdminDashboard from "./pages/adminDashboard";
import Register from './pages/register';
import PrescriptionTransferForm from './pages/prescriptionTransferPage';
import ScrollToTop from './components/scrollToTop';
import BookAppointment from './pages/bookAppointment';
import BlisterPackaging from './pages/ServicesPage/BlisterPackaging';

import PrescriptionTransfer2 from './pages/pre2';

// import FloatingActionMenu from "./components/floatingActionMenu";
import FloatingContactButtons from './components/floatingContactButtons';
import FreeDeliveryPage from './pages/ServicesPage/FreeDeliveryPage';
import StrepLabPage from './pages/ServicesPage/Strep&LabTestingPage';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomePage />} />
        {/* <Route path="/" element={<Dashboard />} /> */}
        <Route path="/contact" element={<Contact />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/testimonials" element={<TestimonialPage />} />
        <Route path="/prescription-transfer" element={<PrescriptionTransferForm />} />
        <Route path="/book-appointment" element={<BookAppointment />} />
        
        <Route path="/services/blister-packaging" element={<BlisterPackaging />} />
        <Route path="/services/delivery" element={<FreeDeliveryPage />} />
        <Route path="/services/strep-lab-testing" element={<StrepLabPage />} />

        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/admin" element={<AdminDashboard />} />

        <Route path="/prescription-transfer2" element={<PrescriptionTransfer2 />} />
      </Routes>

      {/* <FloatingActionMenu /> */}
      <FloatingContactButtons />
    </Router>
  );
}

export default App;